import React from 'react'
import PropTypes from 'prop-types'

export default function PaymentMethods ({ title, children }) {
    return (
        <div className={'mtt-payment-methods'}>
            { title && <div className={'mtt-payment-methods__title'}>{ title }</div>}
            <div className="mtt-payment-methods__grid">
                { children }
            </div>
        </div>
    )
}

PaymentMethods.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array])
}